import "./TransicionColor.css";

// Franja fija (sin animación de scroll) que difumina el cambio de color de
// fondo entre dos secciones contiguas. Va fuera de cualquier AnimarAlScroll:
// si quedara adentro, se escalaría/movería con la animación de entrada de la
// sección y el degradé se vería desalineado mientras esa animación corre.
function TransicionColor({ desde, hasta, compacta = false }) {
  return (
    <div
      className={"transicion-color" + (compacta ? " transicion-color-compacta" : "")}
      aria-hidden="true"
      style={{ background: `linear-gradient(to bottom, ${desde}, ${hasta})` }}
    />
  );
}

export default TransicionColor;
